import { Input } from 'antd'
import styled from 'styled-components'

const StyledInput = styled(Input)`
  &.ant-input-affix-wrapper-status-error {
    background-color: ${p => p.theme.input.bg} !important;
  }
  &.ant-input-affix-wrapper {
    background-color: ${p => p.theme.input.bg};
    border-color: ${p => p.theme.input.borderColor};
    > input {
      background-color: transparent !important;
    }
    &:hover,
    &:focus {
      border-color: ${p => p.theme.input.hoverAndFocusBorderColor};
    }
    & svg[data-icon='close-circle'] {
      fill: ${p => p.theme.input.clearIconFill};
    }
    &.ant-input-affix-wrapper-disabled {
      background-color: ${p => p.theme.input.disabledBg};
    }
  }
  &.ant-input-affix-wrapper .ant-input,
  &.ant-input {
    background: ${p => p.theme.input.bg};
    border-radius: 4px;
    color: ${p => p.theme.input.color};
    border-color: ${p => p.theme.input.borderColor};
    &:hover,
    &:focus {
      border-color: ${p => p.theme.input.hoverAndFocusBorderColor};
    }

    &::placeholder {
      color: ${p => p.theme.input.placeholderColor};
    }

    &:disabled {
      background: ${p => p.theme.input.disabledBg} !important;
      color: ${p => p.theme.input.disabledColor} !important;
    }
    &.ant-input-status-error {
      background-color: ${p => p.theme.input.bg} !important;
    }
    &:-webkit-autofill {
      box-shadow: 0 0 0 1000px rgb(71 74 75) inset !important;
      -webkit-text-fill-color: #fff !important;
      border-color: #6b6d6d !important;
      color: #fff !important;
    }
  }

  &.ant-input-group-wrapper {
    &.custom-input-addon .ant-input-group-addon {
      background: ${p => p.theme.whisper};
      color: ${p => p.theme.darkGrey};
      font-weight: 500;
    }
  }

  &.sks-search {
    &.ant-input-affix-wrapper:not(.ant-input-affix-wrapper-disabled) {
      border-radius: 4px;

      .ant-input {
        font-size: 16px;
      }

      &:hover,
      &:focus {
        border-color: ${p => p.theme.input.hoverAndFocusBorderColor};
      }
      &:focus {
        box-shadow: none;
      }
    }

    &.ant-input-affix-wrapper-focused {
      box-shadow: none;
      border-color: ${p => p.theme.input.hoverAndFocusBorderColor};
    }
  }

  &.placeholder-sm {
    .ant-input {
      ::placeholder {
        font-size: 13px;
      }
    }
  }
`

const PasswordInput = styled(StyledInput.Password)`
  &.ant-input-affix-wrapper {
    background-color: ${p => p.theme.input.bg};
    border-color: ${p => p.theme.input.borderColor};
    > input {
      background-color: transparent !important;
    }
    &:hover,
    &:focus {
      border-color: ${p => p.theme.input.hoverAndFocusBorderColor};
    }
    & svg[data-icon='close-circle'] {
      fill: ${p => p.theme.input.clearIconFill};
    }
    &.ant-input-affix-wrapper-disabled {
      background-color: ${p => p.theme.input.disabledBg};
    }
  }
  &.ant-input-affix-wrapper .ant-input,
  &.ant-input {
    background: ${p => p.theme.input.bg};
    border-radius: 4px;
    color: ${p => p.theme.input.color};
    border-color: ${p => p.theme.input.borderColor};
    &:-webkit-autofill {
      box-shadow: 0 0 0 1000px rgb(71 74 75) inset !important;
      -webkit-text-fill-color: #fff !important;
    }
    &:hover,
    &:focus {
      border-color: ${p => p.theme.input.hoverAndFocusBorderColor};
    }

    &::placeholder {
      color: ${p => p.theme.input.placeholderColor};
    }

    &:disabled {
      background: ${p => p.theme.input.disabledBg} !important;
      color: ${p => p.theme.input.disabledColor} !important;
    }
    &.ant-input-status-error {
      background-color: ${p => p.theme.input.bg} !important;
    }
  }
  .ant-input-password-icon {
    color: #fff;
  }
  &.ant-input-affix-wrapper-status-error {
    background-color: ${p => p.theme.input.bg} !important;
  }
`

export default Object.assign(StyledInput, {
  Password: PasswordInput,
})
